import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "../src/bootstrap.css"
import { BrowserRouter } from "react-router-dom";
import 'react-loading-skeleton/dist/skeleton.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
